<div class="form-element-container" [class.invalid]="groupErrors">
	<label [for]="inputId + '_0'" [class.required]="required">{{ label }}</label>
	@for (control of formArray.controls; track control; let i = $index) {
		<div class="row no-gutters align-items-center mb-2" [class.invalid]="controlErrors(control)">
			<div class="col">
				<input
					type="email"
					class="form-control"
					[id]="inputId + '_' + i"
					[formControl]="control"
					[maxlength]="maxEmailLength"
					[placeholder]="placeholder" />
			</div>
			<div class="col-auto pl-2 text-center">
				<a
					href="javascript:void(0)"
					class="no-right-margin bigger-icon"
					[class.invisible]="formArray.length === 1 && !control.value"
					[attr.aria-label]="'Remove ' + label + ' ' + (i + 1)"
					(click)="remove(i)">
					<fa-icon [icon]="['fas', 'trash']"></fa-icon>
				</a>
			</div>
			@if (controlErrors(control); as errors) {
				<p class="col-12 mb-0 invalid-feedback">
					@if (errors.email) {
						Valid email is required
					} @else if (errors.maxlength) {
						Email must be {{ maxEmailLength }} characters or fewer
					}
				</p>
			}
		</div>
	}
	<a href="javascript:void(0)" class="btn btn-link py-0 px-0" (click)="add()"> <fa-icon [icon]="['far', 'plus-square']"></fa-icon> Add Email </a>
	@if (groupErrors; as errors) {
		<p class="mb-0 invalid-feedback">
			@if (errors.required) {
				{{ label }} is required
			} @else if (errors.maxTotalLength) {
				{{ label }} must be {{ errors.maxTotalLength.requiredLength }} characters or fewer combined
			} @else if (errors.duplicateEmail) {
				Each email can only be added once
			}
		</p>
	}
</div>
